import React, { Component } from "react";
import './cost-report-summary.component.css';
import { CostReportMonthlySummary } from "./cost-report-month-summary.component";
import { LineChartData } from "../../../dashboard/usage-chart/line-chart.component";
import { ChartHeaderDropdown } from "../../../../common/data-header/chart-header-dropdown.component";
export class CostReportSummary extends Component {    
   render() {
       const data=[{
           header:"Previous Month",
           listItem:[{
               itemName:"Gross",
               itemPrice:"122,911",
           }, {
            itemName:"Tax",
            itemPrice:"122,911",
        }, {
            itemName:"Net",
            itemPrice:"108,044.47 ",
        }]
       },{
        header:"Current Month",
        listItem:[{
            itemName:"Gross",
            itemPrice:"122,911",
        }, {
         itemName:"Tax",
         itemPrice:"122,911",
     }, {
         itemName:"Net",
         itemPrice:"108,044.47 ",
     }]
    } ];

    const dataChart=[
        {
            lineData:[
                { name: 'Dec 2020', voice: 70, message: 55, data: 90, other:80 },
                { name: 'Jan 2021', voice: 50, message: 60, data: 65, other:75 },
                { name: 'Feb 2021', voice: 60, message: 30, data: 32, other:20 },
                { name: 'Mar 2021',  voice: 30, message: 68, data: 46, other:46 },
                { name: 'April 2021', voice: 25, message: 30, data: 74, other:53 },
                { name: 'May 2021', voice: 72, message: 90, data: 50, other:80 },                
              ], firstLineColor: "#008eff",
              secondLineColor: "#ffc82c",
              thirdLineColor: "#d5002f",
              forthLineColor: "#919eab", 
        }
    ];
    const  barData = [{name: 'Wireless', color:'#008eff'}, 
                    {name: 'Wireline', color:'#ffc82c'}, 
                    {name: 'HOC', color:'#d5002f'}, 
                    {name: 'Others', color:'#919eab'}
                ]
       return(
            <>
                <div className="cost-report-summary-wrapper">                   
                    <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={true} ledger={barData} headerName="Cost Summary Trend" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                   haveInput={false} haveDropdown={false}  /> 
                   
                    <div className="cost-report-summary">
                        {data.map((item,id)=>
                            <CostReportMonthlySummary key={id} header={item.header} itemList={item.listItem}/>                
                        )}   
                    </div>
                    {dataChart.map((item,id)=>
                        <LineChartData key={id} lineData={item.lineData} firstLineColor={item.firstLineColor}  toolTipEnable={false} secondLineColor={item.secondLineColor}
                        thirdLineColor={item.thirdLineColor} forthLineColor={item.forthLineColor} 
                        />
                    )}   
                </div>              
                            
            </>
       );
   }
}